import React, { useState, useEffect } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { NAV_LINKS, LOGO_URL } from '../data';

export default function Navbar() {
  const [scrolled,    setScrolled]    = useState(false);
  const [mobileOpen,  setMobileOpen]  = useState(false);
  const location = useLocation();

  /* Navbar shadow on scroll */
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  /* Close mobile nav on route change */
  useEffect(() => {
    setMobileOpen(false);
    document.body.style.overflow = '';
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const openMob = () => { setMobileOpen(true);  document.body.style.overflow = 'hidden'; };
  const closeMob= () => { setMobileOpen(false); document.body.style.overflow = '';       };

  /* Close on ESC */
  useEffect(() => {
    const onKey = e => { if (e.key === 'Escape') closeMob(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <>
      <nav style={{
        position:       'sticky',
        top:            0,
        zIndex:         1000,
        background:     'rgba(255,255,255,.97)',
        backdropFilter: 'blur(24px)',
        borderBottom:   '1px solid rgba(123,82,171,.13)',
        boxShadow:      scrolled ? '0 4px 24px rgba(123,82,171,.10)' : 'none',
        transition:     'box-shadow .3s',
      }}>
        <div className="container">
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', height:70 }}>

            {/* Logo */}
            <Link to="/" aria-label="ITClave Home" style={{ display:'flex', alignItems:'center' }}>
              <img
                src={LOGO_URL}
                alt="ITClave — Best IT Company Patna Bihar"
                style={{ height:40, width:'auto', background:'transparent', display:'block' }}
              />
            </Link>

            {/* Desktop links */}
            <ul style={{ display:'flex', alignItems:'center', gap:2, listStyle:'none' }}
                className="nav-desktop-links">
              {NAV_LINKS.slice(0, -1).map(link => (
                <li key={link.path}>
                  <NavLink
                    to={link.path}
                    style={({ isActive }) => ({
                      fontSize:        '.83rem',
                      fontWeight:      600,
                      color:           isActive ? 'var(--purple)' : 'var(--text2)',
                      padding:         '7px 12px',
                      borderRadius:    9,
                      background:      isActive ? 'var(--purple-lt)' : 'transparent',
                      transition:      'all .3s',
                      whiteSpace:      'nowrap',
                      display:         'block',
                    })}
                  >
                    {link.label}
                  </NavLink>
                </li>
              ))}
              <li>
                <Link to="/contact" style={{
                  background:   'linear-gradient(135deg,#E8315B 0%,#7B52AB 50%,#4BB8E8 100%)',
                  color:        '#fff',
                  padding:      '9px 20px',
                  borderRadius: 100,
                  fontWeight:   700,
                  fontSize:     '.82rem',
                  boxShadow:    '0 4px 16px rgba(123,82,171,.3)',
                  whiteSpace:   'nowrap',
                  transition:   'all .3s',
                  display:      'block',
                }}>
                  Get Free Quote
                </Link>
              </li>
            </ul>

            {/* Hamburger */}
            <button
              onClick={openMob}
              aria-label="Open menu"
              aria-expanded={mobileOpen}
              style={{ display:'none', flexDirection:'column', gap:5, padding:6, borderRadius:8, border:'none', background:'none', cursor:'pointer' }}
              className="hamburger-btn"
            >
              <span style={hamLine} />
              <span style={hamLine} />
              <span style={hamLine} />
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Nav Overlay */}
      <div
        style={{
          position:        'fixed',
          inset:           0,
          background:      '#fff',
          zIndex:          9999,
          display:         'flex',
          flexDirection:   'column',
          alignItems:      'center',
          justifyContent:  'center',
          gap:             18,
          transform:       mobileOpen ? 'translateX(0)' : 'translateX(100%)',
          transition:      'transform .42s cubic-bezier(.4,0,.2,1)',
          overflowY:       'auto',
          padding:         '60px 24px 40px',
        }}
        role="dialog"
        aria-modal="true"
        aria-label="Mobile navigation"
      >
        <button
          onClick={closeMob}
          style={{
            position: 'absolute', top:18, right:18,
            width:38, height:38, borderRadius:'50%',
            background:'#F4F2FA', border:'none', cursor:'pointer',
            display:'flex', alignItems:'center', justifyContent:'center',
            fontSize:'1.1rem', color:'#9289AE',
          }}
          aria-label="Close menu"
        >✕</button>

        <Link to="/" style={{ marginBottom:8 }}>
          <img src={LOGO_URL} alt="ITClave" style={{ height:34, background:'transparent' }}/>
        </Link>

        {/* Divider */}
        <div style={{ width:40, height:2, background:'linear-gradient(135deg,#E8315B,#4BB8E8)', borderRadius:2, margin:'4px 0' }}/>

        {NAV_LINKS.map(link => (
          <Link
            key={link.path}
            to={link.path}
            style={{
              fontFamily:   "'Outfit', sans-serif",
              fontSize:     '1.55rem',
              fontWeight:   800,
              color:        location.pathname === link.path ? 'var(--purple)' : 'var(--text)',
              letterSpacing:'-.03em',
              transition:   'color .3s',
            }}
          >
            {link.label}
          </Link>
        ))}
      </div>

      {/* Responsive styles */}
      <style>{`
        @media(max-width:1024px) {
          .nav-desktop-links { display: none !important; }
          .hamburger-btn     { display: flex !important; }
        }
      `}</style>
    </>
  );
}

const hamLine = {
  display:      'block',
  width:        22,
  height:       2,
  background:   'var(--purple)',
  borderRadius: 2,
};
